import React, { FC } from 'react';
import { View } from 'react-native';
import NCFilesList from '@components/machines/components/detailsComponents/activeMachine/components/NCFilesList';
import { isPhone, isWeb } from '@helpers';
import { getBoxShadowStyle } from '@styles/shadow';
import NcFile from '@components/machines/components/detailsComponents/activeMachine/components/NCFile';
import { scale } from '@components/frame';
import ColorWrapper from '@styles/colors';
import { NOT_PANEL_VIEW_MODE_WIDTH } from '@v2/pages/common/constants/base.constants';
import { NCFileSearchItem } from '@interfaces/search';
import Loading from '@components/loading';
import { Machine } from '@interfaces/machines';
import { WithColor } from '@styles/colors';
import { useManageNCFileGeneralContent } from '@v2/pages/machines/modules/now/components/NC-file/hooks/useManageNCFileGeneralContent';

export interface NCFileGeneralContentProps extends WithColor {
  maxDetailsWidth?: number;
  noMachine?: boolean;
  shouldGetNCFileData?: boolean;
  ncFileData?: (NCFileSearchItem | null)[];
  ncFileDataLoading: boolean;
  withImages?: boolean;
  currentNcFileId?: string | number | null;
  ncFileDataLoadingForList?: boolean;
  bg?: string;
}

const NCFileGeneralContent: FC<NCFileGeneralContentProps> = (props) => {
  const {
    C,
    maxDetailsWidth: defaultMaxDetailsWidth = scale(NOT_PANEL_VIEW_MODE_WIDTH),
    noMachine,
    ncFileData,
    ncFileDataLoading,
    withImages,
    currentNcFileId,
    ncFileDataLoadingForList,
    bg,
  } = props;

  const {
    ncFileStyle,
    shouldNotShowLoader,
    borderRadiusConfig,
    ncFileProps,
    shouldDisplaySingleNCFIle,
    maxDetailsWidth,
  } = useManageNCFileGeneralContent({
    maxDetailsWidth: defaultMaxDetailsWidth,
    noMachine,
    ncFileData,
    ncFileDataLoading,
    currentNcFileId,
    ncFileDataLoadingForList,
  });

  return (
    <View
      style={{
        flex: 1,
        width: '100%',
        alignItems: 'center',
        marginTop: scale(shouldDisplaySingleNCFIle ? -2 : 0),
      }}
    >
      <View
        style={[
          {
            flex: 1,
            width: '100%',
          },
          { maxWidth: maxDetailsWidth },
        ]}
      >
        <View
          style={[
            ncFileStyle,
            {
              width: '100%',
              flex: 1,
            },
          ]}
        >
          {(ncFileDataLoading || !shouldNotShowLoader) && (
            <View style={{ marginTop: scale(40) }}>
              <Loading background="transparent" />
            </View>
          )}
          {!ncFileDataLoading && shouldNotShowLoader && ncFileData && (ncFileData?.length > 1 || ncFileData?.length === 0) && (
            <View
              style={[
                ncFileStyle,
                !isWeb && {
                  overflow: 'hidden',
                },
                borderRadiusConfig,
                isWeb && !isPhone && getBoxShadowStyle({ type: 'Field', C }),
              ]}
            >
              <NCFilesList
                {...{ ...props, ...ncFileProps, ncFilesByPartId: ncFileData, ncFilesByPartIdLoaded: !ncFileDataLoading, noMachine, maxDetailsWidth }}
              />
            </View>
          )}
          {shouldDisplaySingleNCFIle && <NcFile {...{ ...props, ...ncFileProps, noMachine, withImages, shouldScroll: false, bg }} />}
        </View>
      </View>
    </View>
  );
};

export default ColorWrapper(NCFileGeneralContent);
